import React, { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { AppContext } from '../../../context/appContext';

const Card = ({ icon, content }) => {
  const [settings] = useContext(AppContext);

  return (
    <Root>
      {icon && (
        <Icon icon={icon} size="3x" color={settings?.iconColor || `#E7C37A`} />
      )}
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </Root>
  );
};

export default Card;

Card.propTypes = {
  icon: PropTypes.string,
  content: PropTypes.string
};

Card.defaultProps = {
  icon: '',
  content: ''
};

const Root = styled.div`
  width: 30%;
  text-align: center;
  margin-bottom: 1rem;

  @media (max-width: 1200px) {
    width: 30%;
  }

  @media (max-width: 960px) {
    width: 90%;
    max-width: 400px;
  }
`;

const Icon = styled(FontAwesomeIcon)`
  margin-bottom: 16px;
`;
